import * as R from 'ramda'
import { isActionType } from 'helpers/ramda-ext/actions'
import * as Actions from 'store/actions'
import { RegisteredAction } from 'store/actions/index.types'
import { InitialState, State } from './context.types'

export const initialState: Readonly<InitialState> = {}

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state: State = initialState, action: RegisteredAction): State => R.cond([
  [
    isActionType(Actions.context.SET_CONTEXT),
    ({ payload }) => R.pick(['desktop', 'mobile', 'webview', 'name'], payload, state)
  ], [
    R.T,
    R.always(state)
  ]
])(action)
